var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _circle, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorLocation = function SvgErrorLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ErrorLocation_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M110.26 74.811c1.731 1.716 3.414 3.5 5.222 5.14 1.173 1.067 1.192 1.772 0 2.898-7.674 7.246-16.405 12.87-26.367 16.418-25.435 9.067-49.62 6.349-72.343-8.133-3.77-2.403-7.039-5.587-10.549-8.38-1.106-.888-1.144-1.593-.077-2.613 3.702-3.576 7.337-7.218 10.963-10.87.961-.953 1.625-1.077 2.702-.066C27.6 76.45 36.658 81.466 47.1 83.716c20.04 4.329 37.975-.086 53.582-13.367 2.712-2.307 2.673-2.345 5.183.124l4.385 4.348z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ErrorLocation_svg__b",
    width: 208,
    height: 113,
    x: -48,
    y: -8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M60.612 104.616c-25.071 0-43.705-12.196-48.787-16.94l-59.524-50.185L60.61-8 159.5 32l-48.746 54.999c-16.601 14.229-40.316 17.617-50.142 17.617"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ErrorLocation_svg__b)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M61.57 84.857v22.5l25.715-2.571L80.856 81z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "m80.857 81 6.429 23.786L116.215 108 99.5 85.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M6.285 108 23 84.214 42.928 81l-7.714 23.786z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "m42.927 81-7.714 23.786 26.357 2.571v-22.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE2E9",
    d: "M61.596 78.971v29l27.619-3.314L82.31 74z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFD3DB",
    d: "m82.31 74 6.905 30.657 31.072 4.143-17.953-29z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE2E9",
    d: "m2.215 108.8 17.952-30.657L41.572 74l-8.286 30.657z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFD3DB",
    d: "m41.573 74-8.286 30.657 28.31 3.314v-29z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 84,
    fill: "#CDD2DC",
    opacity: 0.7,
    rx: 16,
    ry: 3,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38,
    cy: 86.799,
    fill: "#CDD2DC",
    opacity: 0.7,
    rx: 3.5,
    ry: 1,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D9AE8",
    d: "M36.89 72.996c-2.946 0-5.34 2.345-5.34 5.246 0 1.108.353 2.138.951 2.986.03.049.055.097.09.14l3.638 4.496a.83.83 0 0 0 .663.349c.24 0 .478-.112.66-.349l3.637-4.498q.048-.067.087-.134c.6-.85.954-1.878.954-2.99-.003-2.901-2.392-5.246-5.34-5.246m0 7.344c-1.18 0-2.136-.94-2.136-2.098 0-1.159.957-2.098 2.136-2.098s2.136.94 2.136 2.098-.957 2.098-2.136 2.098"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E3EC",
    d: "M61.14 20.773c4.923 0 9.48 1.546 13.205 4.175.547 5.624 4.014 10.343 8.786 12.47a22.5 22.5 0 0 1 .803 5.946c0 4.79-1.51 9.22-4.074 12.876-.11.189-.227.389-.37.578L63.968 76.19c-.779 1.018-1.795 1.501-2.823 1.501-1.027 0-2.054-.489-2.828-1.5L42.791 56.823c-.154-.183-.26-.39-.388-.6a22.4 22.4 0 0 1-4.055-12.86c0-12.493 10.215-22.59 22.793-22.59m0 13.555c-5.035 0-9.118 4.046-9.118 9.036 0 4.985 4.082 9.037 9.119 9.037 5.03 0 9.113-4.052 9.118-9.037 0-4.984-4.088-9.036-9.118-9.036"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFD3DB",
    d: "M61.143 20.773c4.92 0 9.477 1.544 13.202 4.172.546 5.626 4.014 10.347 8.789 12.475.52 1.894.8 3.886.802 5.944 0 4.627-1.41 8.917-3.816 12.5a36.7 36.7 0 0 1-10.78-8.551 8.9 8.9 0 0 0 .92-3.949c0-4.646-3.552-8.48-8.109-8.98A36.5 36.5 0 0 1 60.5 23.497q0-1.37.1-2.716.27-.007.543-.007"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F45149",
    transform: "matrix(-1 0 0 1 99 13)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M89.03 19.24q-.675 0-1.151-.478a1.57 1.57 0 0 1-.479-1.15q0-.674.478-1.134A1.57 1.57 0 0 1 89.03 16q.674 0 1.134.478.478.46.478 1.133 0 .674-.478 1.151a1.51 1.51 0 0 1-1.133.479M87.7 30.575V20.64h2.851v9.934z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231815",
    strokeMiterlimit: 10,
    strokeWidth: 0.513,
    d: "M40.434 68.962s-8.51-17.283-16.679-17.322c-8.168-.04-.973 11.702 4.391 7.518 5.365-4.185-.39-17.936-8.1-20.727"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.52,
    d: "m103 51.8-16 16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ErrorLocation_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v120H0z"
  })))));
};
export default SvgErrorLocation;